import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { BookingService } from '../../services/booking.service';

@Component({
  selector: 'app-payment-failed',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="layout-pt-lg layout-pb-lg">
      <div class="container">
        <div class="row justify-center">
          <div class="col-lg-8">
            <div class="bg-white rounded-4 shadow-1 p-40 text-center">
              
              <div class="mb-30">
                <div class="size-80 rounded-full warn-icon-circle mx-auto d-flex items-center justify-center">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                </div>
              </div>

              <h2 class="text-30 fw-700 text-dark-1 mb-15">Ödeme Tamamlanamadı</h2>

              <p class="text-18 text-light-1 mb-30">
                {{ errorMessage || 'Ödeme işlemi tamamlanamadı.' }}
              </p>

              <!-- Error Details -->
              <div *ngIf="errorReason" class="soft-alert mb-30" style="text-align: left;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                <div>
                  <div class="fw-600 mb-5">Hata Detayı</div>
                  <div>{{ errorReason }}</div>
                </div>
              </div>
              
              <!-- Common Issues -->
              <div class="text-left mb-30">
                <div class="text-16 fw-600 text-dark-1 mb-15">Olası Nedenler:</div>
                <ul class="text-14 text-light-1" style="list-style: disc; padding-left: 20px;">
                  <li class="mb-10">Kart limitiniz yetersiz olabilir</li>
                  <li class="mb-10">Kart bilgileri hatalı girilmiş olabilir</li>
                  <li class="mb-10">3D Secure doğrulaması tamamlanmamış olabilir</li>
                  <li class="mb-10">Bankanız ödemeyi reddetmiş olabilir</li>
                </ul>
              </div>
              
              <!-- Actions -->
              <div class="row y-gap-20">
                <div class="col-md-6">
                  <button (click)="retryPayment()" 
                          class="button h-50 px-30 bg-blue-1 text-white w-100">
                    <i class="icon-refresh mr-10"></i>
                    Tekrar Dene
                  </button>
                </div>
                <div class="col-md-6">
                  <button (click)="goToHome()" 
                          class="button h-50 px-30 bg-light-2 text-dark-1 w-100">
                    Ana Sayfa
                  </button>
                </div>
              </div>
              
              <!-- Support -->
              <div class="mt-30 pt-30 border-top-light">
                <p class="text-14 text-light-1">
                  Sorun devam ederse lütfen müşteri hizmetleri ile iletişime geçin.
                  <br>
                  <a href="tel:+902422120224" class="text-blue-1">0242 212 02 24</a>
                </p>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .size-80 {
      width: 80px;
      height: 80px;
    }
    
    .warn-icon-circle {
      background-color: #fffbeb;
      border: 2px solid #fde68a;
    }
    
    .rounded-full {
      border-radius: 50%;
    }
    
    .mx-auto {
      margin-left: auto;
      margin-right: auto;
    }
  `]
})
export class PaymentFailedComponent implements OnInit {
  errorMessage: string = '';
  errorReason: string = '';
  isLoading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private bookingService: BookingService
  ) {}

  ngOnInit(): void {
    // Backend başarısız yönlendirmelerde ?result=failed ekliyor
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      if (params['result'] === 'failed') {
        this.errorMessage = 'Ödeme işlemi başarısız oldu.';
        this.isLoading = false;
      }
    });
    
    this.loadErrorFromSession();
  }

  /**
   * Session'dan hata bilgisini alır
   */
  private loadErrorFromSession(): void {
    this.bookingService.getLastPaymentError()
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          
          if (response.success === false) {
            this.errorMessage = response.message || 'Ödeme işlemi başarısız oldu.';
            this.errorReason = response.error || response.reason || '';
          } else {
            this.errorMessage = 'Ödeme işlemi başarısız oldu.';
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.errorMessage = 'Ödeme işlemi başarısız oldu. Lütfen tekrar deneyin veya farklı bir kart kullanın.';
        }
      });
  }

  retryPayment(): void {
    // Transaction key varsa ödeme sayfasına dön
    const transactionKey = sessionStorage.getItem('currentTransactionKey');
    
    if (transactionKey) {
      this.router.navigate(['/odeme'], {
        queryParams: { transactionKey }
      });
    } else {
      // Transaction key yoksa ana sayfaya dön
      this.router.navigate(['/']);
    }
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }
}

